import { ThunderboltOutlined } from '@ant-design/icons';
import { Button, message, Tooltip } from 'antd';
import React, { useState } from 'react';
import { addRandomNodesAndEdges } from '../controller/stress-test';

const StressTestButton: React.FC = () => {
  const [loading, setLoading] = useState(false);

  const handleClick = () => {
    if (loading) {
      return;
    }
    setLoading(true);
    window.requestAnimationFrame(() => {
      try {
        const start = performance.now();
        addRandomNodesAndEdges();
        const duration = Math.round(performance.now() - start);
        message.success(`Added 1000 nodes & connections in ${duration} ms`);
      } catch (error) {
        console.error(error);
        message.error('Failed to run stress test');
      } finally {
        setLoading(false);
      }
    });
  };

  return (
    <Tooltip placement="bottom" title={'Add 1000 random nodes & links'}>
      <Button
        size='middle'
        icon={<ThunderboltOutlined />}
        loading={loading}
        onClick={handleClick}
        style={{ height: 32 }}
      >
        Stress test
      </Button>
    </Tooltip>
  );
};

export default StressTestButton;
